import { environment as base } from '@haleo-frontend/utils';

export const environment = {
    ...base,
    appId: 'ca.haleo.dev',
    amplitudeKey: '3ddce39873a1366f01d92cb0503d38db',
    firebaseConfig: {
        apiKey: 'AIzaSyBwTa82wDHRG-vb7Zsg44V4XLXrbPTucnk',
        authDomain: 'haleo-dev.firebaseapp.com',
        projectId: 'haleo-dev',
        storageBucket: 'haleo-dev.appspot.com',
        messagingSenderId: '1073122969308',
        appId: '1:1073122969308:web:5a156010d05ffddc3c9619',
        measurementId: 'G-7T1MKYEKXT'
    },
    sentryDSN: 'https://0c5f0cb86920459cabec4f47ef4e0c2c@sentry-relay.haleo.ca/5593117',
    zoomWebSDKURL: 'https://haleo-dev.firebaseapp.com/assets/html/zoom-external.html',
    appDynamicLink: 'https://haleoclinicdev.page.link/back-to-app',
    growthBookKey: 'sdk-Hgvw2mSgNsjKMVJ'
};
